import Vue from "vue";

Vue.directive('my-only-alphanumeric-enter-others', (el, binding, vNode) => {

	const t = binding.value;
	let maxChars = 191;
	if(t && t.maxChars){
		maxChars = t.maxChars;
	}
	let element = null;

	if (el.getElementsByTagName('INPUT')[0]) {
		element = el.getElementsByTagName('INPUT')[0];
		element.setAttribute('maxlength', maxChars);
	} else if (el.getElementsByTagName('TEXTAREA')[0]) {
		element = el.getElementsByTagName('TEXTAREA')[0];
		element.setAttribute('maxlength', maxChars);
	}

	let handler = function(e) {
		let string = e.target.value;
		let value = string ? string:'';
		let newValue = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑÜü0-9@.:;*,\-_ \n?¿]/gi,'');
		vNode.child.$emit('input', newValue);
	};
	el.addEventListener('input', handler);

});
